'use client'

/**
 * #920: shown by the segment error boundaries when the connection dropped
 * while a page was loading. "Try again" reloads the page: that is Next's own
 * recovery for a failed navigation, whereas the boundary's reset() would
 * re-render the same broken payload.
 */
export default function ConnectionLostNotice({ homeHref, homeLabel }: { homeHref: string; homeLabel: string }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="text-center max-w-md">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Connection lost</h2>
        <p className="text-gray-600 mb-6">The page did not finish loading. Check your internet, then try again.</p>
        <div className="flex gap-4 justify-center">
          <button
            onClick={() => window.location.reload()}
            className="px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 font-semibold"
          >
            Try again
          </button>
          <a
            href={homeHref}
            className="px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 font-semibold"
          >
            {homeLabel}
          </a>
        </div>
      </div>
    </div>
  )
}
